module.exports = __webpack_public_path__ + "img/grey.900451b.svg";